const firebaseConfig = {
    apiKey: 'AIzaSyBFKdALM-tQ5BXODhe5hsZSHxUgUgWQM-E',
    authDomain: 'cactus-sketchbooks.firebaseapp.com',
    databaseURL: 'https://cactus-sketchbooks-default-rtdb.firebaseio.com',
    projectId: 'cactus-sketchbooks',
    storageBucket: 'cactus-sketchbooks.appspot.com',
    messagingSenderId: '36904152582',
    appId: '1:36904152582:web:4f866461bb3c93059b9d87',
    measurementId: 'G-YFYMTZ2910',
};

//para testes
// const firebaseConfig = {
//     apiKey: 'AIzaSyAmshVW9uubTCoKO3X-Xpkv9kNbZz_sXh0',
//     authDomain: 'cactus-sketchbooks-2.firebaseapp.com',
//     databaseURL: 'https://cactus-sketchbooks-2-default-rtdb.firebaseio.com',
//     projectId: 'cactus-sketchbooks-2',
//     storageBucket: 'cactus-sketchbooks-2.appspot.com',
//     messagingSenderId: '588919767267',
//     appId: '1:588919767267:web:874f63cf64bd0f01d705d6',
//     measurementId: 'G-F196BCM2YR',
// };

export default firebaseConfig;
